exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#menu-mobile {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    background-color: #F6F6F6;\r\n    color: #9D9EA0;\r\n    height: 20vh;\r\n    width: 100vw;\r\n\r\n    font-size: 3em;\r\n    color: pink;\r\n\r\n    visibility: none;\r\n    display: none;\r\n}", ""]);

// exports
